<template>
  <div
    class="relative block cursor-pointer"
    v-on:mouseleave="nested.hide.value = true"
    v-on:mouseover="nested.hide.value = false"
  >
    <slot name="title" />
    <Transition name="slide-fade">
      <ul
        v-show="!nested.hide.value"
        class="absolute block shadow-xl z-10"
        style="top: 1.6rem; right: -0.5rem; border-radius: 1rem"
      >
        <li v-for="(value, index) in itemList" :key="index" class="rounded">
          <button
            class="drop-card-item border-r border-l"
            :class="{
              'list-round-first border-t': index == 0,
              'list-round-last border-b': index == itemList.length - 1
            }"
            v-on:click="click(index)"
          >
            {{ value }}
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    itemList: {
      type: Array,
      required: true
    },
    selected: {
      type: Function,
      required: true
    }
  },
  setup(props) {
    const click = (index: number) => {
      const value = props.itemList[index]
      props.selected(index, value)
      hide.value = true
    }

    const hide = ref(true)

    return { click, nested: { hide } }
  }
})
</script>

<style lang="postcss" scoped>
.drop-card-item {
  @apply w-full pl-3 pr-5 inline-flex cursor-pointer bg-white text-gray-800 dark:bg-dark-200 dark:text-dark-text  dark:border-dark-200 whitespace-nowrap;
  min-width: 200px;
  &:hover {
    @apply bg-primary-50 dark:bg-dark-10;
  }
}
</style>
